import { AxiosError } from "axios";

import { logger } from "@/util/logger";

import { RestInterceptor } from "./rest-interceptor";

export const TokenExpiredInterceptor = new RestInterceptor((client, onExpired: () => Promise<void>) => {
  return client.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      if (!(error instanceof AxiosError)) {
        return Promise.reject(error);
      }

      const { config } = error;

      const hasFailedDueToAccessTokenExpiry = error.response?.status === 401;

      if (config && hasFailedDueToAccessTokenExpiry) {
        logger.info(`${config.url}: access token expired`);
        await onExpired();
      }

      return Promise.reject(error);
    },
  );
});
